import React, { createContext, useState } from 'react';

import { HeadCell, RowCell } from '../../index_table.context';

/**
 * Note:
 * Hoverable row data includes 'child' field
 * Hoverable row headCells includes cell that name is 'child'
 */

type HoverableRowContextType = {
  row: RowCell | null;

  /**
   * parent row headCells
   */
  parentRowHeadCells: HeadCell[];

  /**
   * child row headCell
   */
  childRowHeadCell: HeadCell | null;

  /**
   * Set hover status of parent row
   */
  setParentHover: (hover: boolean) => void;

  /**
   * Set hover status of child row
   */
  setChildHover: (hover: boolean) => void;

  /**
   * Parent row expanded status
   */
  expanded: boolean;
};

const defaultHoverableRowContextValue = {
  row: null,
  parentRowHeadCells: [],
  childRowHeadCell: null,
  setParentHover: () => {},
  setChildHover: () => {},
  expanded: false,
};

export const HoverableRowContext = createContext<HoverableRowContextType>(
  defaultHoverableRowContextValue
);

interface HoverableRowProviderProps {
  row: RowCell;
  headCells: HeadCell[];
  children?: React.ReactNode;
}

export const HoverableRowProvider = ({
  row,
  headCells,
  children,
}: HoverableRowProviderProps) => {
  const [parentHover, setParentHover] = useState(false);
  const [childHover, setChildHover] = useState(false);

  const parentRowHeadCells = headCells.filter(
    headCell => headCell.name !== 'child'
  );
  const childRowHeadCell = headCells.find(
    headCell => headCell.name === 'child'
  );

  const expanded = row.expanded ? row.expanded : parentHover || childHover;

  return (
    <HoverableRowContext.Provider
      value={{
        row,
        parentRowHeadCells: parentRowHeadCells || [],
        childRowHeadCell: childRowHeadCell || null,
        setParentHover,
        setChildHover,
        expanded,
      }}
    >
      {children}
    </HoverableRowContext.Provider>
  );
};
